import { z } from "zod";
import { atom } from "jotai";

import { JotaiTool } from "../../index";
import { ContinueButton } from "./ContinueButton";

/**
 * Tool parameters for showing a Continue button in build mode
 */
export const ContinueButtonParamsSchema = z.object({});

export type ContinueButtonResult = {
  success: boolean;
  message: string;
};

/**
 * Continue button tool for build mode in Canvas AI toolkit
 * Shows a purple "Continue" button that sends a continue message to chat
 * Use when pausing in build mode for user confirmation
 */
export const continueButtonAtom = atom<
  JotaiTool<z.infer<typeof ContinueButtonParamsSchema>>
>(() => ({
  name: "continue_button",
  description:
    "🚨 CRITICAL: BUTTON TOOL - ENDS RESPONSE IMMEDIATELY 🚨\n\nShow a Continue button in build mode when pausing for user confirmation. Use after completing tasks, creating assets, or at checkpoints.\n\nMANDATORY BEHAVIOR:\n- This tool shows a button and MUST be the LAST tool call in any response\n- After calling this tool, DO NOT output any additional text or call any other tools\n- The response MUST end immediately to prevent UX conflicts\n- NEVER use with auth buttons (auth_confirmation_button, create_auth) in the same response",
  parameters: ContinueButtonParamsSchema,
  component: ContinueButton,
  execute: atom(null, async () => {
    const result: ContinueButtonResult = {
      success: true,
      message: 'Showing "Continue" button for user confirmation',
    };

    return {
      content: [
        {
          type: "text",
          text: result.message,
        },
      ],
      // Mark as waiting for user input to prevent multiple buttons
      waitingForUser: true,
    };
  }),
}));
